module.exports = __webpack_public_path__ + "static/violin_en-75b9ace93ccc60ce149e4ce8e465e342.pdf";